import React from 'react';
import PropTypes from 'prop-types';
import { FooterWrapper } from './Footer.styled';

const Footer = () => (
 <FooterWrapper>
    <p>Contact us at <a href="https://chargeathome.org/contact-us/" target="_blank" rel="noreferrer">Charge at Home</a> for more information or to provide feedback on this tool.</p>
 </FooterWrapper>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
